interface EmptyStateProps {
  message: string
}

const EmptyState = ({ message }: EmptyStateProps) => {
  return (
    <div className="category-grid">
      <div className="empty-state">
        <p>{message}</p>
      </div>
    </div>
  )
}

export default EmptyState
